import type { ShapeCommand } from "../history/historyTypes";
import { normalizedShapeRect } from "./shapeGeometry";
import type { ActiveShape } from "./shapeTypes";

export function renderShape(
  context: CanvasRenderingContext2D,
  shape: Readonly<ActiveShape | ShapeCommand>,
): void {
  const { tool, geometry, style, clipRect } = shape;
  const rect = normalizedShapeRect(geometry);
  context.save();
  context.globalAlpha = Math.min(1, Math.max(0.1, style.opacity));
  context.globalCompositeOperation = "source-over";
  context.strokeStyle = style.colour;
  context.fillStyle = style.colour;
  context.lineWidth = Math.min(64, Math.max(1, style.size));
  context.lineCap = "round";
  context.lineJoin = "round";
  context.beginPath();
  context.rect(clipRect.x, clipRect.y, clipRect.width, clipRect.height);
  context.clip();
  context.beginPath();
  if (tool === "line") {
    context.moveTo(geometry.start.x, geometry.start.y);
    context.lineTo(geometry.end.x, geometry.end.y);
    context.stroke();
  } else if (tool === "rectangle") {
    context.rect(rect.x, rect.y, rect.width, rect.height);
    if (style.mode === "solid") context.fill();
    else context.stroke();
  } else {
    context.ellipse(
      rect.x + rect.width / 2,
      rect.y + rect.height / 2,
      Math.max(0.5, rect.width / 2),
      Math.max(0.5, rect.height / 2),
      0,
      0,
      Math.PI * 2,
    );
    if (style.mode === "solid") context.fill();
    else context.stroke();
  }
  context.restore();
}
